import { ChangeDetectionStrategy, Component } from '@angular/core';

import { User } from '@commons/models/domain/User';
import { UserHttpService } from '@shared/services-http/user-http.service';

@Component({
  selector: 'app-handover-add',
  templateUrl: './handover-add.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandoverAddComponent {

  public emailIsSended: boolean;

  private get user(): User | undefined {
    return this.userHttpService?.userViewModel?.user;
  }

  constructor(private userHttpService: UserHttpService) { }

  public sendEmail(): void {
    const email = "rozwoj@tekom.pl";
    const subject = "Elektroniczne protokoły przekazania pojazdu";
    const msgBody = `Jestem zainteresowany funkcją elektronicznych protokołów. Proszę o kontakt: ${ this.user?.Email }`;
    this.emailIsSended = true;
    window.open(`mailto:${email}?subject=${subject}&body=${msgBody}`);
  }
}
